
import request from '@/utils/request'
export function findModelList(params) {
  return request({
      url: '/aiModelX/findModelList',
      method: 'get',
      params,
  })
}
export function createModel(data) {
  return request({
      url: '/aiModelX/createModel',
      method: 'post',
      data,
  })
}
export function updateModel(data) {
  return request({
      url: '/aiModelX/updateModel',
      method: 'post',
      data,
  })
}
export function removeModel(data) {
  return request({
      url: '/aiModelX/removeModel',
      method: 'post',
      data,
  })
}

export function findModel(params) {
  return request({
      url: '/aiModelX/findModel',
      method: 'get',
      params,
  })
}

export function findModelInstanceList(params) {
  return request({
      url: '/aiModelX/findModelInstanceList',
      method: 'get',
      params,
  })
}
export function createModelInstance(data) {
  return request({
      url: '/aiModelX/createModelInstance',
      method: 'post',
      data,
  })
}
export function updateModelInstance(data) {
  return request({
      url: '/aiModelX/updateModelInstance',
      method: 'post',
      data,
  })
}
export function removeModelInstance(data) {
  return request({
      url: '/aiModelX/removeModelInstance',
      method: 'post',
      data,
  })
}

export function findModelInstance(params) {
  return request({
      url: '/aiModelX/findModelInstance',
      method: 'get',
      params,
  })
}

export function findModelTaskList(params) {
  return request({
      url: '/aiModelX/findModelTaskList',
      method: 'get',
      params,
  })
}

export function removeModelTask(data) {
  return request({
      url: '/aiModelX/removeModelTask',
      method: 'post',
      data,
  })
}

export function findModelTask(params) {
  return request({
      url: '/aiModelX/findModelTask',
      method: 'get',
      params,
  })
}